import sortBy from 'lodash/sortBy';
import flattenDeep from 'lodash/flattenDeep';
import last from 'lodash/last';

/**
 * create a label and sort key from any category label
 * @params {string} label eg Skill 1.A, Practice 1.1
 * @return {object} containing the label and some two sort keys
 * */
export const getKeysFromLabel = (label) => {
  const match = label && label.match(/(\d+.\w+)/);

  if (match) {
    const key = match[0] || '';
    const sortKeys = key.split('.');
    const sortKey1 = parseInt(sortKeys[0], 10);
    const sortKey2 = sortKeys[1];
    return {
      label: key,
      sortKey1,
      sortKey2,
    };
  }

  return { label };
};

/**
 * Go deep and get last level values
 * @param {array} levelList The object whithin to look
 * @param {array} hierarchy The hierarchy levels
 * @param {number} maxLevels Max depth levels
 * @param {number} level The depth level
 * @prams {parent} the category to look at
 * @return {array}  array of skills
 * */
export const getSkillsWithParentCategory = (
  levelList,
  hierarchy,
  widgetTagColumnLabel,
  maxLevels,
  level = 0,
  parent = null,
) => {
  const skills =
    lookUpSkillsInHierarchy(
      levelList,
      hierarchy,
      widgetTagColumnLabel,
      maxLevels,
      level,
      parent,
    ) || [];
  return flattenDeep(skills);
};

/**
 * Go deep and get last level values
 * @param {array} levelList The object whithin to look
 * @param {array} hierarchy The hierarchy levels
 * @param {number} maxLevels Max depth levels
 * @param {number} level The depth level
 * @return {array}  array of next arrays of  skills
 * */

export const lookUpSkillsInHierarchy = (
  levelList,
  hierarchy,
  widgetTagColumnLabel,
  maxLevels,
  level = 0,
  parent = null,
) => {
  const currentHierarchyLevel = hierarchy[level];
  let found = [];
  const nextLevel = level + 1;
  levelList.forEach((list) => {
    const { label, children, name, category } = list;
    const parentCategoryName = name;
    if (
      (label && label.indexOf(currentHierarchyLevel) === 0) ||
      category === currentHierarchyLevel ||
      currentHierarchyLevel === widgetTagColumnLabel
    ) {
      if (children && children.length) {
        const tempFound = getSkillsWithParentCategory(
          children,
          hierarchy,
          widgetTagColumnLabel,
          maxLevels,
          nextLevel,
          parentCategoryName,
        );
        if (tempFound.length) {
          found.push(tempFound);
        }
      } else if (label && maxLevels === level) {
        const keys = getKeysFromLabel(label);
        found.push({
          name,
          category: parent,
          ...keys,
        });
      }
    }
  });
  return found;
};

export const sortSkills = (skills = []) =>
  sortBy(skills, ['sortKey1', 'sortKey2']);

export const getSortedSkillsWithParentCategory = (
  widgetTagColumn,
  widgetTagColumnLabel,
  metadata,
) => {
  const hierarchy = widgetTagColumn.split('>');
  const metadataItems = (metadata && JSON.parse(metadata)) || [];
  const skills = getSkillsWithParentCategory(
    metadataItems,
    hierarchy,
    widgetTagColumnLabel,
    hierarchy.length - 1,
    0,
  );

  return sortSkills(skills);
};

export const getSortedSkillsFromCategory = (
  widgetTagColumn = '',
  widgetTagColumnLabel,
  flatMetadata,
) => {
  const hierarchy = widgetTagColumn.split('>');
  const skillLabel = last(hierarchy);
  const { tags = [] } =
    flatMetadata.find(({ label }) => label === skillLabel) || {};
  if (tags.length > 0) {
    return tags.map(({ title, label, description }) => {
      const keys = getKeysFromLabel(label);
      return {
        name: description,
        category: title,
        ...keys,
      };
    });
  }

  return [];
};
